module.exports = __webpack_public_path__ + "static/step-2-1183e54f2e0042fd9afb0cfc1ec5fe2a.svg";